export default "__VITE_ASSET__DFktz6D0__"